import api from './api';

export interface HteStockLot {
  id: string;
  item_number: string;
  item_name: string | null;
  actual_weight: number;
  current_amount: number;
  current_amount_unit: string;
  status: string;
  expiry_date: string | null;
  received_date: string | null;
  location_code: string | null;
  updated_at: string;
}

export interface ByproductBuffer {
  id: string;
  source_material_item_number: string;
  byproduct_item_number: string;
  source_name: string | null;
  byproduct_name: string | null;
  reserved_weight: number;
  target_weight: number;
  last_session_number: string | null;
  last_production_date: string | null;
  status: string;
  updated_at: string;
}

const hteStockService = {
  async getLots(): Promise<HteStockLot[]> {
    const response = await api.get('/inventory/lots/hte-stock');
    return response.data.data;
  },

  async updateLot(id: string, current_amount: number, username: string, password: string, reason: string): Promise<HteStockLot> {
    const response = await api.patch(`/inventory/lots/${id}/current-amount`, { current_amount, username, password, reason });
    return response.data.data;
  },

  async getBuffers(): Promise<ByproductBuffer[]> {
    const response = await api.get('/inventory/byproduct-buffer');
    return response.data.data;
  },

  async updateBuffer(id: string, reserved_weight: number, username: string, password: string, reason: string): Promise<ByproductBuffer> {
    const response = await api.patch(`/inventory/byproduct-buffer/${id}`, { reserved_weight, username, password, reason });
    return response.data.data;
  },

  async deleteBuffer(id: string, username: string, password: string, reason: string): Promise<void> {
    await api.delete(`/inventory/byproduct-buffer/${id}`, { data: { username, password, reason } });
  },
};

export default hteStockService;
